import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";
import config from "../../config/api";

const BackendURL = config.backendUrl;

// -------------------------------------------------------------------
//  THUNK 1: Update Cost Per Service (already added by you)
// -------------------------------------------------------------------
export const updateCostPerService = createAsyncThunk(
    "projects/updateCostPerService",
    async ({ quotationId, TypeService, CostPerService }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.put(
                `${BackendURL}/financial/update-cost-per-service`,
                { quotationId, TypeService, CostPerService }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || "Failed to update cost per service"
            );
        }
    }
);

// -------------------------------------------------------------------
//  🔥 THUNK 2: Update QuotedValue for All Projects Under ProjectName
// -------------------------------------------------------------------
export const updateQuotedValueForProjects = createAsyncThunk(
    "projects/updateQuotedValueForProjects",
    async ({ quotationId, quotedValue }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.put(
                `${BackendURL}/financial/update-quoted-values`,
                { quotationId, quotedValue }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message ||
                "Failed to update quoted value for projects"
            );
        }
    }
);

// -------------------------------------------------------------------
//  SLICE
// -------------------------------------------------------------------
const projectSlice = createSlice({
    name: "projects",
    initialState: {
        loading: false,
        error: null,
        successMessage: null,
        updatedRecords: 0,
    },

    reducers: {
        resetProjectState: (state) => {
            state.loading = false;
            state.error = null;
            state.successMessage = null;
            state.updatedRecords = 0;
        },
    },

    extraReducers: (builder) => {
        builder
            // =====================================================
            //   updateCostPerService
            // =====================================================
            .addCase(updateCostPerService.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.successMessage = null;
            })

            .addCase(updateCostPerService.fulfilled, (state, action) => {
                state.loading = false;
                state.successMessage = action.payload.message;
                state.updatedRecords = action.payload.updatedRecords || 0;
            })

            .addCase(updateCostPerService.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Something went wrong";
            })

            // =====================================================
            //   updateQuotedValueForProjects
            // =====================================================
            .addCase(updateQuotedValueForProjects.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.successMessage = null;
            })

            .addCase(updateQuotedValueForProjects.fulfilled, (state, action) => {
                state.loading = false;
                state.successMessage = action.payload.message;
                state.updatedRecords = action.payload.updatedRecords;
            })

            .addCase(updateQuotedValueForProjects.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Something went wrong";
            });
    },
});

export const { resetProjectState } = projectSlice.actions;

export default projectSlice.reducer;



// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axiosInstance from "../../config/axiosConfig";
// import config from "../../config/api";

// const BackendURL = config.backendUrl;

// // --------------- THUNK: Update Cost Per Service ---------------- //
// export const updateCostPerService = createAsyncThunk(
//     "projects/updateCostPerService",
//     async ({ ProjectName, TypeService, CostPerService }, { rejectWithValue }) => {
//         try {
//             const response = await axiosInstance.put(
//                 `${BackendURL}/financial/update-cost-per-service`,
//                 { ProjectName, TypeService, CostPerService }
//             );
//             return response.data;
//         } catch (error) {
//             return rejectWithValue(
//                 error.response?.data?.message || "Failed to update cost per service"
//             );
//         }
//     }
// );

// // ---------------------- SLICE --------------------------- //
// const projectSlice = createSlice({
//     name: "projects",
//     initialState: {
//         loading: false,
//         error: null,
//         successMessage: null,
//         updatedRecords: 0,
//     },

//     reducers: {
//         resetProjectState: (state) => {
//             state.loading = false;
//             state.error = null;
//             state.successMessage = null;
//             state.updatedRecords = 0;
//         },
//     },

//     extraReducers: (builder) => {
//         builder
//             // ---------- PENDING ----------
//             .addCase(updateCostPerService.pending, (state) => {
//                 state.loading = true;
//                 state.error = null;
//                 state.successMessage = null;
//             })

//             // ---------- SUCCESS ----------
//             .addCase(updateCostPerService.fulfilled, (state, action) => {
//                 state.loading = false;
//                 state.successMessage = action.payload.message;
//                 state.updatedRecords = action.payload.updatedRecords || 0;
//             })

//             // ---------- FAILED ----------
//             .addCase(updateCostPerService.rejected, (state, action) => {
//                 state.loading = false;
//                 state.error = action.payload || "Something went wrong";
//             });
//     },
// });

// export const { resetProjectState } = projectSlice.actions;

// export default projectSlice.reducer;
